// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useContext } from 'react'
import logo from 'images/comsearch-connect-andrew.png'
import Faq from './FAQ'
import { useBooleanToggle } from 'hooks'
import UserInfo from './UserInfo'
import { AuthContext } from 'components/Auth'
import { FaComments } from 'components/FontAwesome'
import NavLink from './NavLink'

import {
  ROLES_PATH_DATABASE,
  ROLES_PROTECTION,
  ROLES_PROJECT_TRACKER,
  ROLES_PRICING_MANAGEMENT,
  ROLES_SUAS,
} from 'constants/userGroups'

import {
  LogoImage,
  NavbarAside,
  NavbarButtons,
  NavbarWrapper,
  NavLinkWrapper,
} from './styles'

import {
  Collapse,
  Nav,
  NavbarBrand,
  NavbarToggler,
} from 'reactstrap'

const Navigation = () => {
  const { user } = useContext(AuthContext)

  const [isOpen, toggleCollapsed] = useBooleanToggle()

  return (
    <NavbarWrapper
      className={'container-fluid'}
      expand={'md'}
      sticky={'top'}>
      <NavbarButtons
        className={'navbar-light'}
        isSignedIn={!!user}>
        <NavbarBrand href='/#/'>
          <LogoImage
            alt={'Comsearch Connect'}
            src={logo}
            title={'Comsearch Connect'} />
        </NavbarBrand>
        {
          user &&
          <NavbarToggler
            className={'mr-2 margin-left-auto'}
            onClick={toggleCollapsed} />
        }
      </NavbarButtons>
      <Collapse
        isOpen={isOpen}
        navbar={true}>
        <Nav
          className={'margin-left-auto'}
          onClick={isOpen ? toggleCollapsed : null}
          navbar={true}>
          <NavLink to={'/'}>
            {'HOME'}
          </NavLink>
          <NavLink
            requiredGroups={ROLES_PROJECT_TRACKER}
            to={'/project-tracker'}>
            {'PROJECT TRACKER'}
          </NavLink>
          <NavLink
            requiredGroups={ROLES_PROTECTION}
            to={'/protection'}>
            {'PROTECTION'}
          </NavLink>
          <NavLink
            requiredGroups={ROLES_PATH_DATABASE}
            to={'/path-database'}>
            {'PATH DATABASE'}
          </NavLink>
          <NavLink
            to={'/data-products'}>
            {'DATA PRODUCTS'}
          </NavLink>         
          <NavLink
            requiredGroups={ROLES_SUAS}
            to={'/rf-drone-services'}>
            {'RF DRONE SERVICES'}
          </NavLink>
        </Nav>
      </Collapse>
      <NavbarAside>
        <NavLinkWrapper
          href={'https://www.comsearch.com/cc-feedback/'}
          rel={'noopener noreferrer'}
          target={'_blank'}
          title={'Share your feedback.'}>
          <FaComments />
        </NavLinkWrapper>
        <Faq />
        <UserInfo />
      </NavbarAside>
    </NavbarWrapper>
  )
}

export default Navigation
